<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  data() {
    return {
      customer_id: null,
      form: {
        amount: '',
        payment_method: 'Cash',
        payment_date: this.todayDate(),
        transaction_id: '',
        notes: '',
      },
      errors: {},
      methods_list: ['Cash', 'Bank Transfer', 'Credit Card', 'Cheque', 'UPI', 'Gateway'],
    };
  },
  methods: {
    todayDate() {
      const d = new Date();
      return d.toISOString().split('T')[0];
    },

    create(customer_id) {
      this.customer_id = customer_id;
      this.errors = {};
      this.form = {
        amount: '',
        payment_method: 'Cash',
        payment_date: this.todayDate(),
        transaction_id: '',
        notes: '',
      };
    },

    selectMethod(method) {
      this.form.payment_method = method;
    },

    async submit() {
      this.setLoading(true);
      this.errors = {};
      try {
        const payload = {
          customer_id: this.customer_id,
          amount: this.form.amount,
          payment_method: this.form.payment_method,
          payment_date: this.form.payment_date,
          transaction_id: this.form.transaction_id || null,
          notes: this.form.notes || null,
        };
        const res = await axios.post('/payments', payload);
        this.$swalToast(res.data.message || 'Payment added successfully');
        this.$emit('updated');
        document.getElementById('payment_add_modal_close').click();
      } catch (error) {
        if (error.type === 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>

<template>
  <div class="modal fade" id="payment_add_modal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title">Add Payment</h5>
          <button type="button" id="payment_add_modal_close" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">

          <!-- Amount -->
          <div class="mb-3">
            <label class="form-label">Amount <span class="text-danger">*</span></label>
            <input type="number" step="0.01" class="form-control" v-model="form.amount" placeholder="Enter amount" />
            <span class="text-danger small" v-if="errors.amount">{{ errors.amount[0] }}</span>
          </div>

          <!-- Payment Method - pill buttons -->
          <div class="mb-3">
            <label class="form-label">Payment Method <span class="text-danger">*</span></label>
            <div class="pm-pill-group">
              <button
                type="button"
                v-for="method in methods_list"
                :key="method"
                class="pm-pill"
                :class="{ active: form.payment_method === method }"
                @click="selectMethod(method)"
              >
                {{ method }}
              </button>
            </div>
            <span class="text-danger small" v-if="errors.payment_method">{{ errors.payment_method[0] }}</span>
          </div>

          <!-- Date -->
          <div class="mb-3">
            <label class="form-label">Payment Date <span class="text-danger">*</span></label>
            <input type="date" class="form-control" v-model="form.payment_date" />
            <span class="text-danger small" v-if="errors.payment_date">{{ errors.payment_date[0] }}</span>
          </div>

          <!-- Transaction ID -->
          <div class="mb-3">
            <label class="form-label">Transaction ID</label>
            <input type="text" class="form-control" v-model="form.transaction_id" placeholder="Enter transaction / reference ID" />
            <span class="text-danger small" v-if="errors.transaction_id">{{ errors.transaction_id[0] }}</span>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label class="form-label">Notes</label>
            <textarea class="form-control" rows="2" v-model="form.notes" placeholder="Any additional notes"></textarea>
            <span class="text-danger small" v-if="errors.notes">{{ errors.notes[0] }}</span>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="submit">Save Payment</button>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
.pm-pill-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}
.pm-pill {
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
}
.pm-pill:hover { background: #f9fafb; }
.pm-pill.active {
  background: #f97316;
  border-color: #f97316;
  color: #fff;
}
</style>